import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: null,
  isLoggedIn: false,
  role: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,

  reducers: {

    signIn: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isLoggedIn = true;
      state.role = action.payload.user.role.name;

    },


    updateUser: (state, action) => {
      state.user = action.payload;
      state.role = action.payload.role.name;

    },
    
    signOut: (state) => {
      state.user = null;
      state.token = null;
      state.isLoggedIn = false;
      state.role = 'null';

    },
  },
});

export const { signIn, updateUser, signOut } = authSlice.actions;
export default authSlice.reducer;
